<template>
  <div
    v-if="
      (!$store.getters['auth/logged_in'] && $route.name !== 'residences' && $route.name !== 'residences-list') ||
        $route.name === 'null'
    "
  >
    <app-content-empty />
  </div>
  <div v-else-if="$route.name !== 'iframe' && $route.name !== 'login'" id="app">
    <app-header />
    <app-content />
    <app-footer />
  </div>
  <router-view v-else />
</template>

<script>
import AppContent from '@/components/layout/AppContent'
import AppContentEmpty from '@/components/layout/AppContentEmpty'
import AppFooter from '@/components/layout/AppFooter'
import AppHeader from '@/components/layout/AppHeader'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    AppContent,
    AppContentEmpty
  }
}
</script>

<style lang="scss">
body {
  font-size: 16px;
  color: $--color-text-primary;
}

@include respond-below(sm) {
  body {
    font-size: 14px;
  }
}
</style>
